import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Section = styled.section`
  padding: 96px 0;
  background: ${themeGet('colors.background')};
  @media (max-width: 1024px) {
    padding: 72px 0;
  }
  @media (max-width: 768px) {
    padding: 56px 0;
  }
`;

export const SectionHeading = styled.div`
  text-align: center;
  h2 {
    font-weight: 800;
    font-size: 36px;
    line-height: 1.25;
    letter-spacing: -0.03em;
    @media (max-width: 600px) {
      font-size: 28px;
    }
  }
`;

export const Grid = styled.div`
  margin-top: 56px;
  gap: 24px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  @media (max-width: 1219px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 768px) {
    margin-top: 40px;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Item = styled.div`
  text-align: center;
  padding: 32px 24px;
  border: 1px solid ${themeGet('colors.borderColor')};
  border-radius: 20px;
  background: ${themeGet('colors.white')};
  box-shadow: ${themeGet('colors.cardShadow')};
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-4px);
    box-shadow: ${themeGet('colors.pricingShadow')};
  }
  figure {
    width: 64px;
    height: 64px;
    margin: 0 auto 24px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: ${themeGet('colors.secondary')};
    color: ${themeGet('colors.headingColor')};
    font-size: 30px;
  }
  h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    @media (max-width: 1024px) {
      font-size: 17px;
    }
    @media (max-width: 480px) {
      font-size: 16px;
      margin-bottom: 8px;
    }
  }
  p {
    color: ${themeGet('colors.textColor')};
    font-size: 16px;
    font-weight: 500;
    line-height: 2;
    @media (min-width: 769px) and (max-width: 1024px) {
      font-size: 15px;
      line-height: 1.9;
    }
    @media (max-width: 480px) {
      font-size: 15px;
      max-width: 320px;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export default Section;
